<template>
  <div>
    <b-row>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <h2>{{ $t("tripPlan.waypoints") }}</h2>

    <router-link :to="'/workflow/waypointCreate'">
      <b-button size="sm">
        {{ $t('geral.create') }}
      </b-button>
    </router-link>
    <b-table
      ref="table"
      class="table-nowrap"
      :busy.sync="isBusy"
      :items="myProvider"
      :fields="fields"
      :filter="tableFilters"
      :filter-debounce="500"
      :per-page="tablePerPage"
      :current-page="tableCurrentPage"
    >
      <template slot="thead-top" slot-scope="{ fields }">
        <b-tr>
          <b-th v-for="field in fields" :key="field.key">
            <div v-if="tableFilters[field.filterKey] != null">
              <b-form-select
                v-if="field.filterKey == 'active'"
                :options="optionsBoolean"
                v-model="tableFilters[field.filterKey]"
              >
              </b-form-select>
              <b-form-input
                v-else
                v-model="tableFilters[field.filterKey]"
                :placeholder="'Buscar por ' + field.label"
              />
            </div>
          </b-th>
        </b-tr>
      </template>
      <template v-slot:cell(actions)="data">
        <router-link :to="'/workflow/waypointEdit/' + data.item.id">
          <b-button size="sm">
            {{ $t("geral.edit") }}
          </b-button>
        </router-link>
        <b-button
          v-if="data.item.active"
          class="ml-2"
          size="sm"
          @click="deactivate(data.item.id)"
          :disabled="submitted"
        >
          {{ $t("geral.deactivate") }}
        </b-button>
        <b-button
          v-if="data.item.active == false"
          class="ml-2"
          size="sm"
          @click="activate(data.item.id)"
          :disabled="submitted"
        >
          {{ $t("geral.activate") }}
        </b-button>
        <b-button size="sm" class="ml-2" @click="openModal(data.item.id)">
          {{ $t("workflow.path") }}
        </b-button>
      </template>
    </b-table>

    <waypoint-trip-plans-modal
      ref="waypointModal"
      :id="waypointId"
    ></waypoint-trip-plans-modal>

    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </div>
</template>
<script>
export default {
  name: "WaypointList",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    WaypointTripPlansModal: () =>
      import("@/components_rms/workflow/Waypoint/WaypointTripPlansModal.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Ponto de parada alterado com sucesso!",
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          thStyle: { width: "350px", minWidth: "350px" },
        },
        {
          key: "name",
          filterKey: "name",
          label: "Nome",
          thStyle: { width: "300px", minWidth: "300px" },
        },
        {
          key: "fullAddress",
          filterKey: "fullAddress",
          label: "Endereço",
        },
        {
          key: "active",
          filterKey: "active",
          label: "Ativo",
          formatter: (value, key, item) => {
            if (item.active) {
              return "Sim";
            }
            return "Não";
          },
          thStyle: { width: "100px", minWidth: "100px" },
          // tdClass: "table-col-dinamic-width",
        },
      ],
      waypointId: 0,
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      tableFilters: {
        name: "",
        fullAddress: "",
        active: true,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      submitted: false,
    };
  },
  methods: {
    myProvider(ctx, callback) {
      this.isBusy = true;
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        active: ctx.filter.active,
        name: ctx.filter.name,
        fullAddress: ctx.filter.fullAddress,
      };
      this.$apiWorkflow
        .post("/waypoint/getList/", apiParam)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          console.log("Error");
          console.log(error.response);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    openModal(id) {
      this.waypointId = id;
      this.$refs.waypointModal.show();
    },
    deactivate(id) {
      this.submitted = true;
      this.$apiWorkflow.post("/waypoint/desactive/" + id).then((response) => {
        this.$refs.alert.show();
        this.submitted = false;
        this.$refs.table.refresh();
      });
    },
    activate(id) {
      this.submitted = true;
      this.$apiWorkflow.post("/waypoint/activate/" + id).then((response) => {
        this.$refs.alert.show();
        this.submitted = false;
        this.$refs.table.refresh();
      });
    },
  },
};
</script>
